import { useLocation } from 'react-router-dom';

function useStaffIdQuery() {
    const location = useLocation();
    const params = new URLSearchParams(location.search.toLowerCase());
    const staffId = params.get('staffid');

    return staffId;
}

export default useStaffIdQuery;
